import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { SubscriptionTier } from "@/lib/subscription-tiers";
import { queryKeys } from "@/lib/query-keys";

export function usePublicTier(profileId: string | undefined | null) {
  return useQuery({
    queryKey: queryKeys.user.publicTier(profileId ?? undefined),
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_public_user_tier", {
        p_profile_id: profileId!,
      } as any);
      if (error) return "free" as SubscriptionTier;
      return (data as string as SubscriptionTier) || "free";
    },
    enabled: !!profileId,
    staleTime: 5 * 60_000,
  });
}
